import Vue from 'vue'
import axios from 'axios'

import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/public.css'
// 引入全局基本样式
import '@/assets/css/base.css'

// 引入字体样式
import '@/assets/font/iconfont.css'
import loading from '@/utils/loading' // 引入loading
Vue.use(loading) // 全局使用loading
import loadings from '@/utils/loadings.js' // 引入loading
Vue.use(loadings) // 全局使用loading
import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar)
import Print from 'vue-print-nb'
Vue.use(Print);  //注册

// if (!process.env.IS_WEB) Vue.use(require('vue-electron'))
Vue.http = Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small' })
/* eslint-disable no-new */
new Vue({
  components: { App },
  router,
  store,
  template: '<App/>'
}).$mount('#app')

// let ipc ='';
// let fs = '';
// if (!process.env.IS_WEB) {
//   ipc= require('electron').ipcRenderer;
//   fs = require('fs')
//   Vue.use(require('vue-electron'))
// }

// if (process.env.IS_WEB) {

// }
// 键盘事件
Vue.prototype.$keyBoard = function (vm, methodName, code) {
  document.onkeydown = function () {
    let key = window.event.keyCode;
    if (key == code) {
      vm[methodName](code); // 触发methodName事件
    }
  };
}

